
import { appConstants } from '../constants/appConstants';

const VERSION_KEY = appConstants.localStorageMetaPrefix + 'versions';
const DATA_KEY_PREFIX = appConstants.localStorageDataPrefix;
const META_KEY_PREFIX = appConstants.localStorageMetaPrefix;

/**
 * DataStorageService provides an asynchronous interface for storing application private.
 * Currently uses localStorage, but designed for easy migration to IndexedDB.
 */
export const dataStorageService = {
    /**
     * Get stored version information
     */
    async getVersionInfo() {
        const info = localStorage.getItem(VERSION_KEY);
        return info ? JSON.parse(info) : null;
    },

    /**
     * Save version information
     */
    async saveVersionInfo(info) {
        localStorage.setItem(VERSION_KEY, JSON.stringify(info));
    },

    /**
     * Get private for a specific file/key
     */
    async getData(key) {
        const data = localStorage.getItem(DATA_KEY_PREFIX + key);
        return data ? JSON.parse(data) : null;
    },

    /**
     * Save private for a specific file/key
     */
    async saveData(key, data) {
        localStorage.setItem(DATA_KEY_PREFIX + key, JSON.stringify(data));
    },

    /**
     * Clear only data files (prefixed with DATA_KEY_PREFIX)
     */
    async clearData() {
        Object.keys(localStorage).forEach(key => {
            if (key.startsWith(DATA_KEY_PREFIX)) {
                localStorage.removeItem(key);
            }
        });
    },

    /**
     * Clear all stored private (both data and meta)
     */
    async clearAll() {
        Object.keys(localStorage).forEach(key => {
            if (key.startsWith(DATA_KEY_PREFIX) || key.startsWith(META_KEY_PREFIX)) {
                localStorage.removeItem(key);
            }
        });
    }
};
